import { combineReducers } from "@reduxjs/toolkit";


import authReducer from '../redux/features/auth/authSlice';
import staffReducer from '../redux/features/staff/staffSlice';
import courseReducer from '../redux/features/course/courseSlice';
import bulkReducer from '../redux/features/bulkUpload/bulkUploadSlice';
import certificateReducer from '../redux/features/certificate/certificateSlice';
import certificateEntityReducer from '../redux/features/certificateEntity/certificateEntitySlice';
import certificateTypeReducer from '../redux/features/certificateType/certificateTypeSlice';
import certificateTemplateReducer from '../redux/features/certificateTemplate/certificateTemplateSlice';
import activityLogReducer from '../redux/features/activityLog/activityLogSlice';
import dashboardReducer from '../redux/features/dashboard/dashboardSlice';
import roleReducer from '../redux/features/role/roleSlice';
import certificateTemplateVersionReducer from '../redux/features/certificateTemplateVersion/certificateTemplateVersionSlice';
import lookupReducer from '../redux/features/lookup/lookupSlice';

const appReducer = combineReducers({
  auth: authReducer,
  staff: staffReducer,
  course: courseReducer,
  bulk: bulkReducer,
  certificate: certificateReducer,
  certificateEntity: certificateEntityReducer,
  certificateType: certificateTypeReducer,
  certificateTemplate: certificateTemplateReducer,
  activityLog: activityLogReducer,
  dashboard: dashboardReducer,
  role: roleReducer,
  certificateTemplateVersion: certificateTemplateVersionReducer,
  lookup: lookupReducer,
});

const rootReducer = (state, action) => {
  if (
    action.type === "auth/signOut/fulfilled" ||
    action.type === "auth/signOut/rejected"
  ) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
